/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Page Designer components that must only be placed inside a specific parent region
 * (FAQ Section → FAQ; Question → FAQ Section; Year → Timeline; events → Year; Timeline → About Us;
 * Download Tile → Download Tiles).
 *
 * Applied automatically to regions without a componentTypeInclusions whitelist.
 */
export const NESTED_ONLY_PAGE_DESIGNER_COMPONENTS = [
    'Content.faqQuestion',
    'Layout.faqSection',
    'Layout.oneColumnEvent',
    'Layout.twoColumnEvent',
    'Layout.timelineYear',
    'Layout.timeline',
    'Content.downloadTile',
] as const;
